import * as tslib_1 from "tslib";
import { Container } from './container';
import { ToolHelper } from '../utility/index';
var ContentContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ContentContainer, _super);
    function ContentContainer(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents,contentTemplate,title,headerTemplate';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                if (key === 'contents') {
                    obj[key].forEach(function (item) {
                        var domObj = ToolHelper.createObjectByType(item.type);
                        if (domObj) {
                            _this.contents.push(new domObj(item));
                        }
                    });
                }
                else {
                    _this[key] = obj[key];
                }
            }
        });
        return _this;
    }
    ContentContainer.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ContentContainer",
            "contentTemplate": this.contentTemplate,
            "headerTemplate": this.headerTemplate,
            "title": this.title,
            "contents": result
        });
    };
    ContentContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ContentContainer;
}(Container));
export { ContentContainer };
//# sourceMappingURL=content_container.js.map